// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/oauth/authorize/native(.:format)`
 * - Path helper: `native_oauth_authorization_path`
 * - URL helper: `native_oauth_authorization_url`
 * - controller#action: `oauth/authorizations#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nativeOauthAuthorizationPath = /*#__PURE__*/ (...args) => {
  const _nativeOrganizationOauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _nativeOauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _nativeOrganizationOauthAuthorizationPath(gon.current_organization.path, ...args);
  }

  return _nativeOauthAuthorizationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/authorize(.:format)`
 * - Path helper: `oauth_authorization_path`
 * - URL helper: `oauth_authorization_url`
 * - controller#action: `oauth/authorizations#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizationPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthAuthorizationPath(gon.current_organization.path, ...args);
  }

  return _oauthAuthorizationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/token(.:format)`
 * - Path helper: `oauth_token_path`
 * - URL helper: `oauth_token_url`
 * - controller#action: `oauth/tokens#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthTokenPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthTokenPath(gon.current_organization.path, ...args);
  }

  return _oauthTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/revoke(.:format)`
 * - Path helper: `oauth_revoke_path`
 * - URL helper: `oauth_revoke_url`
 * - controller#action: `oauth/tokens#revoke`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthRevokePath = /*#__PURE__*/ (...args) => {
  const _organizationOauthRevokePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthRevokePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthRevokePath(gon.current_organization.path, ...args);
  }

  return _oauthRevokePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/introspect(.:format)`
 * - Path helper: `oauth_introspect_path`
 * - URL helper: `oauth_introspect_url`
 * - controller#action: `oauth/tokens#introspect`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthIntrospectPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthIntrospectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthIntrospectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthIntrospectPath(gon.current_organization.path, ...args);
  }

  return _oauthIntrospectPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/applications(.:format)`
 * - Path helper: `oauth_applications_path`
 * - URL helper: `oauth_applications_url`
 * - controller#action: `oauth/applications#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthApplicationsPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthApplicationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthApplicationsPath(gon.current_organization.path, ...args);
  }

  return _oauthApplicationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/applications/new(.:format)`
 * - Path helper: `new_oauth_application_path`
 * - URL helper: `new_oauth_application_url`
 * - controller#action: `oauth/applications#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOauthApplicationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationOauthApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newOauthApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationOauthApplicationPath(gon.current_organization.path, ...args);
  }

  return _newOauthApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/applications/:id/edit(.:format)`
 * - Path helper: `edit_oauth_application_path`
 * - URL helper: `edit_oauth_application_url`
 * - controller#action: `oauth/applications#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOauthApplicationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationOauthApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editOauthApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationOauthApplicationPath(gon.current_organization.path, ...args);
  }

  return _editOauthApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/applications/:id(.:format)`
 * - Path helper: `oauth_application_path`
 * - URL helper: `oauth_application_url`
 * - controller#action: `oauth/applications#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthApplicationPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _oauthApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthApplicationPath(gon.current_organization.path, ...args);
  }

  return _oauthApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/authorized_applications(.:format)`
 * - Path helper: `oauth_authorized_applications_path`
 * - URL helper: `oauth_authorized_applications_url`
 * - controller#action: `oauth/authorized_applications#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizedApplicationsPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthAuthorizedApplicationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthAuthorizedApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthAuthorizedApplicationsPath(gon.current_organization.path, ...args);
  }

  return _oauthAuthorizedApplicationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/authorized_applications/:id(.:format)`
 * - Path helper: `oauth_authorized_application_path`
 * - URL helper: `oauth_authorized_application_url`
 * - controller#action: `oauth/authorized_applications#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizedApplicationPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthAuthorizedApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _oauthAuthorizedApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthAuthorizedApplicationPath(gon.current_organization.path, ...args);
  }

  return _oauthAuthorizedApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/token/info(.:format)`
 * - Path helper: `oauth_token_info_path`
 * - URL helper: `oauth_token_info_url`
 * - controller#action: `oauth/token_info#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenInfoPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthTokenInfoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _oauthTokenInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthTokenInfoPath(gon.current_organization.path, ...args);
  }

  return _oauthTokenInfoPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/applications/:id/renew(.:format)`
 * - Path helper: `renew_oauth_application_path`
 * - URL helper: `renew_oauth_application_url`
 * - controller#action: `oauth/applications#renew`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewOauthApplicationPath = /*#__PURE__*/ (...args) => {
  const _organizationRenewOauthApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _renewOauthApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationRenewOauthApplicationPath(gon.current_organization.path, ...args);
  }

  return _renewOauthApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/.well-known/oauth-protected-resource(.:format)`
 * - Path helper: `oauth_protected_resource_metadata_path`
 * - URL helper: `oauth_protected_resource_metadata_url`
 * - controller#action: `oauth/protected_resource_metadata#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthProtectedResourceMetadataPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthProtectedResourceMetadataPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"oauth-protected-resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _oauthProtectedResourceMetadataPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"oauth-protected-resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthProtectedResourceMetadataPath(gon.current_organization.path, ...args);
  }

  return _oauthProtectedResourceMetadataPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/register(.:format)`
 * - Path helper: `oauth_register_path`
 * - URL helper: `oauth_register_url`
 * - controller#action: `oauth/dynamic_registrations#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthRegisterPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthRegisterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthRegisterPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthRegisterPath(gon.current_organization.path, ...args);
  }

  return _oauthRegisterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/userinfo(.:format)`
 * - Path helper: `oauth_userinfo_path`
 * - URL helper: `oauth_userinfo_url`
 * - controller#action: `oauth/userinfo#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthUserinfoPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthUserinfoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthUserinfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthUserinfoPath(gon.current_organization.path, ...args);
  }

  return _oauthUserinfoPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/discovery/keys(.:format)`
 * - Path helper: `oauth_discovery_keys_path`
 * - URL helper: `oauth_discovery_keys_url`
 * - controller#action: `jwks#keys`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDiscoveryKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"discovery"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _oauthDiscoveryKeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"discovery"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDiscoveryKeysPath(gon.current_organization.path, ...args);
  }

  return _oauthDiscoveryKeysPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/.well-known/openid-configuration(.:format)`
 * - Path helper: `oauth_discovery_provider_path`
 * - URL helper: `oauth_discovery_provider_url`
 * - controller#action: `jwks#provider`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryProviderPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDiscoveryProviderPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"openid-configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _oauthDiscoveryProviderPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"openid-configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDiscoveryProviderPath(gon.current_organization.path, ...args);
  }

  return _oauthDiscoveryProviderPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/.well-known/webfinger(.:format)`
 * - Path helper: `oauth_discovery_webfinger_path`
 * - URL helper: `oauth_discovery_webfinger_url`
 * - controller#action: `jwks#webfinger`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryWebfingerPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDiscoveryWebfingerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"webfinger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _oauthDiscoveryWebfingerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"webfinger"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDiscoveryWebfingerPath(gon.current_organization.path, ...args);
  }

  return _oauthDiscoveryWebfingerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/authorize_device(.:format)`
 * - Path helper: `oauth_device_codes_create_path`
 * - URL helper: `oauth_device_codes_create_url`
 * - controller#action: `doorkeeper/device_authorization_grant/device_codes#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDeviceCodesCreatePath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDeviceCodesCreatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize_device"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthDeviceCodesCreatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize_device"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDeviceCodesCreatePath(gon.current_organization.path, ...args);
  }

  return _oauthDeviceCodesCreatePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/device(.:format)`
 * - Path helper: `oauth_device_authorizations_index_path`
 * - URL helper: `oauth_device_authorizations_index_url`
 * - controller#action: `oauth/device_authorizations#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDeviceAuthorizationsIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDeviceAuthorizationsIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthDeviceAuthorizationsIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDeviceAuthorizationsIndexPath(gon.current_organization.path, ...args);
  }

  return _oauthDeviceAuthorizationsIndexPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/oauth/device(.:format)`
 * - Path helper: `oauth_device_authorizations_authorize_path`
 * - URL helper: `oauth_device_authorizations_authorize_url`
 * - controller#action: `oauth/device_authorizations#authorize`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDeviceAuthorizationsAuthorizePath = /*#__PURE__*/ (...args) => {
  const _organizationOauthDeviceAuthorizationsAuthorizePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _oauthDeviceAuthorizationsAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOauthDeviceAuthorizationsAuthorizePath(gon.current_organization.path, ...args);
  }

  return _oauthDeviceAuthorizationsAuthorizePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/jira_connect/oauth_application_id(.:format)`
 * - Path helper: `jira_connect_oauth_application_id_options_path`
 * - URL helper: `jira_connect_oauth_application_id_options_url`
 * - controller#action: `jira_connect/oauth_application_ids#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jiraConnectOauthApplicationIdOptionsPath = /*#__PURE__*/ (...args) => {
  const _organizationJiraConnectOauthApplicationIdOptionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jira_connect"],[2,[7,"/"],[2,[6,"oauth_application_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _jiraConnectOauthApplicationIdOptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jira_connect"],[2,[7,"/"],[2,[6,"oauth_application_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationJiraConnectOauthApplicationIdOptionsPath(gon.current_organization.path, ...args);
  }

  return _jiraConnectOauthApplicationIdOptionsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search(.:format)`
 * - Path helper: `search_path`
 * - URL helper: `search_url`
 * - controller#action: `search#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPath = /*#__PURE__*/ (...args) => {
  const _organizationSearchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _searchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchPath(gon.current_organization.path, ...args);
  }

  return _searchPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search/autocomplete(.:format)`
 * - Path helper: `search_autocomplete_path`
 * - URL helper: `search_autocomplete_url`
 * - controller#action: `search#autocomplete`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchAutocompletePath = /*#__PURE__*/ (...args) => {
  const _organizationSearchAutocompletePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _searchAutocompletePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchAutocompletePath(gon.current_organization.path, ...args);
  }

  return _searchAutocompletePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search/settings(.:format)`
 * - Path helper: `search_settings_path`
 * - URL helper: `search_settings_url`
 * - controller#action: `search#settings`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchSettingsPath = /*#__PURE__*/ (...args) => {
  const _organizationSearchSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _searchSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchSettingsPath(gon.current_organization.path, ...args);
  }

  return _searchSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search/count(.:format)`
 * - Path helper: `search_count_path`
 * - URL helper: `search_count_url`
 * - controller#action: `search#count`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchCountPath = /*#__PURE__*/ (...args) => {
  const _organizationSearchCountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _searchCountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchCountPath(gon.current_organization.path, ...args);
  }

  return _searchCountPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search/opensearch(.:format)`
 * - Path helper: `search_opensearch_path`
 * - URL helper: `search_opensearch_url`
 * - controller#action: `search#opensearch`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchOpensearchPath = /*#__PURE__*/ (...args) => {
  const _organizationSearchOpensearchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"opensearch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _searchOpensearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"opensearch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchOpensearchPath(gon.current_organization.path, ...args);
  }

  return _searchOpensearchPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/search/aggregations(.:format)`
 * - Path helper: `search_aggregations_path`
 * - URL helper: `search_aggregations_url`
 * - controller#action: `search#aggregations`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchAggregationsPath = /*#__PURE__*/ (...args) => {
  const _organizationSearchAggregationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"aggregations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _searchAggregationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"aggregations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSearchAggregationsPath(gon.current_organization.path, ...args);
  }

  return _searchAggregationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/jwt/auth(.:format)`
 * - Path helper: `jwt_auth_path`
 * - URL helper: `jwt_auth_url`
 * - controller#action: `jwt#auth`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jwtAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationJwtAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"jwt"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _jwtAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jwt"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationJwtAuthPath(gon.current_organization.path, ...args);
  }

  return _jwtAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/health_check(/:checks)(.:format)`
 * - Path helper: `health_check_path`
 * - URL helper: `health_check_url`
 * - controller#action: `health_check#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthCheckPath = /*#__PURE__*/ (...args) => {
  const _organizationHealthCheckPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"checks":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"health_check"],[2,[1,[2,[7,"/"],[3,"checks"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);
  const _healthCheckPath = /*#__PURE__*/ __jsr.r({"checks":{},"format":{}}, [2,[7,"/"],[2,[6,"health_check"],[2,[1,[2,[7,"/"],[3,"checks"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHealthCheckPath(gon.current_organization.path, ...args);
  }

  return _healthCheckPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/.well-known/terraform.json(.:format)`
 * - Path helper: `terraform_services_path`
 * - URL helper: `terraform_services_url`
 * - controller#action: `terraform/services#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terraformServicesPath = /*#__PURE__*/ (...args) => {
  const _organizationTerraformServicesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"terraform"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);
  const _terraformServicesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"terraform"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationTerraformServicesPath(gon.current_organization.path, ...args);
  }

  return _terraformServicesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/sandbox/mermaid_v11(.:format)`
 * - Path helper: `sandbox_mermaid_v11_path`
 * - URL helper: `sandbox_mermaid_v11_url`
 * - controller#action: `sandbox#mermaid_v11`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sandboxMermaidV11Path = /*#__PURE__*/ (...args) => {
  const _organizationSandboxMermaidV11Path = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[6,"mermaid_v11"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _sandboxMermaidV11Path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[6,"mermaid_v11"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSandboxMermaidV11Path(gon.current_organization.path, ...args);
  }

  return _sandboxMermaidV11Path(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/sandbox/swagger(.:format)`
 * - Path helper: `sandbox_swagger_path`
 * - URL helper: `sandbox_swagger_url`
 * - controller#action: `sandbox#swagger`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sandboxSwaggerPath = /*#__PURE__*/ (...args) => {
  const _organizationSandboxSwaggerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[6,"swagger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _sandboxSwaggerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[6,"swagger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSandboxSwaggerPath(gon.current_organization.path, ...args);
  }

  return _sandboxSwaggerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/:model/:model_id/uploads/:secret/:filename(.:format)`
 * - Path helper: `banzai_upload_path`
 * - URL helper: `banzai_upload_url`
 * - controller#action: `banzai/uploads#show`
 *
 * @param {any} model
 * @param {any} modelId
 * @param {any} secret
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banzaiUploadPath = /*#__PURE__*/ (...args) => {
  const _organizationBanzaiUploadPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"model":{"r":true},"model_id":{"r":true},"secret":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"model"],[2,[7,"/"],[2,[3,"model_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _banzaiUploadPath = /*#__PURE__*/ __jsr.r({"model":{"r":true},"model_id":{"r":true},"secret":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[3,"model"],[2,[7,"/"],[2,[3,"model_id"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationBanzaiUploadPath(gon.current_organization.path, ...args);
  }

  return _banzaiUploadPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/diagram-proxy/:key(.:format)`
 * - Path helper: `diagram_proxy_path`
 * - URL helper: `diagram_proxy_url`
 * - controller#action: `banzai/diagram_proxy#proxy`
 *
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const diagramProxyPath = /*#__PURE__*/ (...args) => {
  const _organizationDiagramProxyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"diagram-proxy"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _diagramProxyPath = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"diagram-proxy"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDiagramProxyPath(gon.current_organization.path, ...args);
  }

  return _diagramProxyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/whats_new(.:format)`
 * - Path helper: `whats_new_path`
 * - URL helper: `whats_new_url`
 * - controller#action: `whats_new#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsNewPath = /*#__PURE__*/ (...args) => {
  const _organizationWhatsNewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"whats_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _whatsNewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"whats_new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationWhatsNewPath(gon.current_organization.path, ...args);
  }

  return _whatsNewPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/whats_new/mark_as_read(.:format)`
 * - Path helper: `whats_new_mark_as_read_path`
 * - URL helper: `whats_new_mark_as_read_url`
 * - controller#action: `whats_new#mark_as_read`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsNewMarkAsReadPath = /*#__PURE__*/ (...args) => {
  const _organizationWhatsNewMarkAsReadPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _whatsNewMarkAsReadPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationWhatsNewMarkAsReadPath(gon.current_organization.path, ...args);
  }

  return _whatsNewMarkAsReadPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/offline(.:format)`
 * - Path helper: `offline_path`
 * - URL helper: `offline_url`
 * - controller#action: `pwa#offline`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offlinePath = /*#__PURE__*/ (...args) => {
  const _organizationOfflinePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"offline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _offlinePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"offline"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationOfflinePath(gon.current_organization.path, ...args);
  }

  return _offlinePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/manifest(.:format)`
 * - Path helper: `manifest_path`
 * - URL helper: `manifest_url`
 * - controller#action: `pwa#manifest`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifestPath = /*#__PURE__*/ (...args) => {
  const _organizationManifestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _manifestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationManifestPath(gon.current_organization.path, ...args);
  }

  return _manifestPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/kubernetes(.:format)`
 * - Path helper: `kubernetes_dashboard_index_path`
 * - URL helper: `kubernetes_dashboard_index_url`
 * - controller#action: `clusters/agents/dashboard#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kubernetesDashboardIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationKubernetesDashboardIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"kubernetes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _kubernetesDashboardIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"kubernetes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationKubernetesDashboardIndexPath(gon.current_organization.path, ...args);
  }

  return _kubernetesDashboardIndexPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/kubernetes/:agent_id(/*vueroute)(.:format)`
 * - Path helper: `kubernetes_dashboard_path`
 * - URL helper: `kubernetes_dashboard_url`
 * - controller#action: `clusters/agents/dashboard#show`
 *
 * @param {any} agentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kubernetesDashboardPath = /*#__PURE__*/ (...args) => {
  const _organizationKubernetesDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"agent_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"kubernetes"],[2,[7,"/"],[2,[3,"agent_id"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);
  const _kubernetesDashboardPath = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"kubernetes"],[2,[7,"/"],[2,[3,"agent_id"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationKubernetesDashboardPath(gon.current_organization.path, ...args);
  }

  return _kubernetesDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/http_router/version(.:format)`
 * - Path helper: `http_router_version_path`
 * - URL helper: `http_router_version_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const httpRouterVersionPath = /*#__PURE__*/ (...args) => {
  const _organizationHttpRouterVersionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"http_router"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _httpRouterVersionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"http_router"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHttpRouterVersionPath(gon.current_organization.path, ...args);
  }

  return _httpRouterVersionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/liveness(.:format)`
 * - Path helper: `liveness_path`
 * - URL helper: `liveness_url`
 * - controller#action: `health#liveness`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const livenessPath = /*#__PURE__*/ (...args) => {
  const _organizationLivenessPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"liveness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _livenessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"liveness"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationLivenessPath(gon.current_organization.path, ...args);
  }

  return _livenessPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/readiness(.:format)`
 * - Path helper: `readiness_path`
 * - URL helper: `readiness_url`
 * - controller#action: `health#readiness`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readinessPath = /*#__PURE__*/ (...args) => {
  const _organizationReadinessPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"readiness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _readinessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"readiness"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationReadinessPath(gon.current_organization.path, ...args);
  }

  return _readinessPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/metrics(.:format)`
 * - Path helper: `metrics_path`
 * - URL helper: `metrics_url`
 * - controller#action: `metrics#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metricsPath = /*#__PURE__*/ (...args) => {
  const _organizationMetricsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _metricsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationMetricsPath(gon.current_organization.path, ...args);
  }

  return _metricsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/metrics/system(.:format)`
 * - Path helper: `metrics_system_path`
 * - URL helper: `metrics_system_url`
 * - controller#action: `metrics#system`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metricsSystemPath = /*#__PURE__*/ (...args) => {
  const _organizationMetricsSystemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"system"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _metricsSystemPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"system"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationMetricsSystemPath(gon.current_organization.path, ...args);
  }

  return _metricsSystemPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/peek`
 * - Path helper: `peek_routes_path`
 * - URL helper: `peek_routes_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peekRoutesPath = /*#__PURE__*/ (...args) => {
  const _organizationPeekRoutesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"peek"]]]]]]]]);
  const _peekRoutesPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"peek"]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationPeekRoutesPath(gon.current_organization.path, ...args);
  }

  return _peekRoutesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/runner_setup/platforms(.:format)`
 * - Path helper: `runner_setup_platforms_path`
 * - URL helper: `runner_setup_platforms_url`
 * - controller#action: `runner_setup#platforms`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runnerSetupPlatformsPath = /*#__PURE__*/ (...args) => {
  const _organizationRunnerSetupPlatformsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runner_setup"],[2,[7,"/"],[2,[6,"platforms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _runnerSetupPlatformsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runner_setup"],[2,[7,"/"],[2,[6,"platforms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationRunnerSetupPlatformsPath(gon.current_organization.path, ...args);
  }

  return _runnerSetupPlatformsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/acme-challenge(.:format)`
 * - Path helper: `acme_challenge_path`
 * - URL helper: `acme_challenge_url`
 * - controller#action: `acme_challenges#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acmeChallengePath = /*#__PURE__*/ (...args) => {
  const _organizationAcmeChallengePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"acme-challenge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _acmeChallengePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"acme-challenge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAcmeChallengePath(gon.current_organization.path, ...args);
  }

  return _acmeChallengePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide`
 * - Path helper: `ide_path`
 * - URL helper: `ide_url`
 * - controller#action: `ide#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const idePath = /*#__PURE__*/ (...args) => {
  const _organizationIdePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"ide"]]]]]]]]);
  const _idePath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[6,"ide"]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdePath(gon.current_organization.path, ...args);
  }

  return _idePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/project`
 * - Path helper: `ide_project_path`
 * - URL helper: `ide_project_url`
 * - controller#action: `ide#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideProjectPath = /*#__PURE__*/ (...args) => {
  const _organizationIdeProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"project"]]]]]]]]]]);
  const _ideProjectPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"project"]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeProjectPath(gon.current_organization.path, ...args);
  }

  return _ideProjectPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/oauth_redirect`
 * - Path helper: `ide_oauth_redirect_path`
 * - URL helper: `ide_oauth_redirect_url`
 * - controller#action: `ide#oauth_redirect`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideOauthRedirectPath = /*#__PURE__*/ (...args) => {
  const _organizationIdeOauthRedirectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"oauth_redirect"]]]]]]]]]]);
  const _ideOauthRedirectPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"oauth_redirect"]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeOauthRedirectPath(gon.current_organization.path, ...args);
  }

  return _ideOauthRedirectPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/project/:project_id/edit`
 * - Path helper: `ide_project_edit_path`
 * - URL helper: `ide_project_edit_url`
 * - controller#action: `ide#index`
 *
 * @param {any} projectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideProjectEditPath = /*#__PURE__*/ (...args) => {
  const _organizationIdeProjectEditPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);
  const _ideProjectEditPath = /*#__PURE__*/ __jsr.r({"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeProjectEditPath(gon.current_organization.path, ...args);
  }

  return _ideProjectEditPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/project/:project_id/tree`
 * - Path helper: `ide_project_tree_path`
 * - URL helper: `ide_project_tree_url`
 * - controller#action: `ide#index`
 *
 * @param {any} projectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideProjectTreePath = /*#__PURE__*/ (...args) => {
  const _organizationIdeProjectTreePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"tree"]]]]]]]]]]]]]]);
  const _ideProjectTreePath = /*#__PURE__*/ __jsr.r({"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"tree"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeProjectTreePath(gon.current_organization.path, ...args);
  }

  return _ideProjectTreePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/project/:project_id/blob`
 * - Path helper: `ide_project_blob_path`
 * - URL helper: `ide_project_blob_url`
 * - controller#action: `ide#index`
 *
 * @param {any} projectId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideProjectBlobPath = /*#__PURE__*/ (...args) => {
  const _organizationIdeProjectBlobPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"blob"]]]]]]]]]]]]]]);
  const _ideProjectBlobPath = /*#__PURE__*/ __jsr.r({"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[6,"blob"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeProjectBlobPath(gon.current_organization.path, ...args);
  }

  return _ideProjectBlobPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/ide/reset_oauth_application_settings`
 * - Path helper: `ide_reset_oauth_application_settings_path`
 * - URL helper: `ide_reset_oauth_application_settings_url`
 * - controller#action: `admin/applications#reset_web_ide_oauth_application_settings`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideResetOauthApplicationSettingsPath = /*#__PURE__*/ (...args) => {
  const _organizationIdeResetOauthApplicationSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"reset_oauth_application_settings"]]]]]]]]]]);
  const _ideResetOauthApplicationSettingsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[6,"reset_oauth_application_settings"]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIdeResetOauthApplicationSettingsPath(gon.current_organization.path, ...args);
  }

  return _ideResetOauthApplicationSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/leakmem(.:format)`
 * - Path helper: `leakmem_chaos_path`
 * - URL helper: `leakmem_chaos_url`
 * - controller#action: `chaos#leakmem`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leakmemChaosPath = /*#__PURE__*/ (...args) => {
  const _leakmemOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"leakmem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _leakmemChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"leakmem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _leakmemOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _leakmemChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/cpu_spin(.:format)`
 * - Path helper: `cpu_spin_chaos_path`
 * - URL helper: `cpu_spin_chaos_url`
 * - controller#action: `chaos#cpu_spin`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cpuSpinChaosPath = /*#__PURE__*/ (...args) => {
  const _cpuSpinOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"cpu_spin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _cpuSpinChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"cpu_spin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _cpuSpinOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _cpuSpinChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/db_spin(.:format)`
 * - Path helper: `db_spin_chaos_path`
 * - URL helper: `db_spin_chaos_url`
 * - controller#action: `chaos#db_spin`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dbSpinChaosPath = /*#__PURE__*/ (...args) => {
  const _dbSpinOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"db_spin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _dbSpinChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"db_spin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _dbSpinOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _dbSpinChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/sleep(.:format)`
 * - Path helper: `sleep_chaos_path`
 * - URL helper: `sleep_chaos_url`
 * - controller#action: `chaos#sleep`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sleepChaosPath = /*#__PURE__*/ (...args) => {
  const _sleepOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"sleep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _sleepChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"sleep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _sleepOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _sleepChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/kill(.:format)`
 * - Path helper: `kill_chaos_path`
 * - URL helper: `kill_chaos_url`
 * - controller#action: `chaos#kill`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const killChaosPath = /*#__PURE__*/ (...args) => {
  const _killOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"kill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _killChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"kill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _killOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _killChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/quit(.:format)`
 * - Path helper: `quit_chaos_path`
 * - URL helper: `quit_chaos_url`
 * - controller#action: `chaos#quit`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quitChaosPath = /*#__PURE__*/ (...args) => {
  const _quitOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"quit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _quitChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"quit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _quitOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _quitChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/chaos/gc(.:format)`
 * - Path helper: `gc_chaos_path`
 * - URL helper: `gc_chaos_url`
 * - controller#action: `chaos#gc`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gcChaosPath = /*#__PURE__*/ (...args) => {
  const _gcOrganizationChaosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"gc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _gcChaosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"chaos"],[2,[7,"/"],[2,[6,"gc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _gcOrganizationChaosPath(gon.current_organization.path, ...args);
  }

  return _gcChaosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/invites/:id/accept(.:format)`
 * - Path helper: `accept_invite_path`
 * - URL helper: `accept_invite_url`
 * - controller#action: `invites#accept`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptInvitePath = /*#__PURE__*/ (...args) => {
  const _acceptOrganizationInvitePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _acceptInvitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _acceptOrganizationInvitePath(gon.current_organization.path, ...args);
  }

  return _acceptInvitePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/invites/:id/decline(.:format)`
 * - Path helper: `decline_invite_path`
 * - URL helper: `decline_invite_url`
 * - controller#action: `invites#decline`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineInvitePath = /*#__PURE__*/ (...args) => {
  const _declineOrganizationInvitePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _declineInvitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _declineOrganizationInvitePath(gon.current_organization.path, ...args);
  }

  return _declineInvitePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/invites/:id(.:format)`
 * - Path helper: `invite_path`
 * - URL helper: `invite_url`
 * - controller#action: `invites#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitePath = /*#__PURE__*/ (...args) => {
  const _organizationInvitePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _invitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationInvitePath(gon.current_organization.path, ...args);
  }

  return _invitePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/sent_notifications/:id/unsubscribe(.:format)`
 * - Path helper: `unsubscribe_sent_notification_path`
 * - URL helper: `unsubscribe_sent_notification_url`
 * - controller#action: `sent_notifications#unsubscribe`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeSentNotificationPath = /*#__PURE__*/ (...args) => {
  const _unsubscribeOrganizationSentNotificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sent_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unsubscribeSentNotificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"sent_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unsubscribeOrganizationSentNotificationPath(gon.current_organization.path, ...args);
  }

  return _unsubscribeSentNotificationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/awarded_achievements/:id/accept(.:format)`
 * - Path helper: `accept_awarded_achievement_path`
 * - URL helper: `accept_awarded_achievement_url`
 * - controller#action: `achievements/awarded_achievements#accept`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptAwardedAchievementPath = /*#__PURE__*/ (...args) => {
  const _acceptOrganizationAwardedAchievementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"awarded_achievements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _acceptAwardedAchievementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"awarded_achievements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _acceptOrganizationAwardedAchievementPath(gon.current_organization.path, ...args);
  }

  return _acceptAwardedAchievementPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/abuse_reports/add_category(.:format)`
 * - Path helper: `add_category_abuse_reports_path`
 * - URL helper: `add_category_abuse_reports_url`
 * - controller#action: `abuse_reports#add_category`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addCategoryAbuseReportsPath = /*#__PURE__*/ (...args) => {
  const _addCategoryOrganizationAbuseReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[6,"add_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _addCategoryAbuseReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"abuse_reports"],[2,[7,"/"],[2,[6,"add_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _addCategoryOrganizationAbuseReportsPath(gon.current_organization.path, ...args);
  }

  return _addCategoryAbuseReportsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/abuse_reports(.:format)`
 * - Path helper: `abuse_reports_path`
 * - URL helper: `abuse_reports_url`
 * - controller#action: `abuse_reports#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abuseReportsPath = /*#__PURE__*/ (...args) => {
  const _organizationAbuseReportsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _abuseReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"abuse_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationAbuseReportsPath(gon.current_organization.path, ...args);
  }

  return _abuseReportsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/jwks(.:format)`
 * - Path helper: `jwks_path`
 * - URL helper: `jwks_url`
 * - controller#action: `jwks#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jwksPath = /*#__PURE__*/ (...args) => {
  const _organizationJwksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jwks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _jwksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"jwks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationJwksPath(gon.current_organization.path, ...args);
  }

  return _jwksPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/snippets/:snippet_id/notes/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_snippet_note_path`
 * - URL helper: `toggle_award_emoji_snippet_note_url`
 * - controller#action: `snippets/notes#toggle_award_emoji`
 *
 * @param {any} snippetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiSnippetNotePath = /*#__PURE__*/ (...args) => {
  const _toggleAwardEmojiOrganizationSnippetNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"snippet_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"snippet_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiSnippetNotePath = /*#__PURE__*/ __jsr.r({"snippet_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"snippet_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationSnippetNotePath(gon.current_organization.path, ...args);
  }

  return _toggleAwardEmojiSnippetNotePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/snippets/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_snippet_path`
 * - URL helper: `toggle_award_emoji_snippet_url`
 * - controller#action: `snippets#toggle_award_emoji`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiSnippetPath = /*#__PURE__*/ (...args) => {
  const _toggleAwardEmojiOrganizationSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiSnippetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationSnippetPath(gon.current_organization.path, ...args);
  }

  return _toggleAwardEmojiSnippetPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/emails/confirmation/new(.:format)`
 * - Path helper: `new_email_confirmation_path`
 * - URL helper: `new_email_confirmation_url`
 * - controller#action: `confirmations#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEmailConfirmationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationEmailConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newEmailConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationEmailConfirmationPath(gon.current_organization.path, ...args);
  }

  return _newEmailConfirmationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/emails/confirmation(.:format)`
 * - Path helper: `email_confirmation_path`
 * - URL helper: `email_confirmation_url`
 * - controller#action: `confirmations#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailConfirmationPath = /*#__PURE__*/ (...args) => {
  const _organizationEmailConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _emailConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationEmailConfirmationPath(gon.current_organization.path, ...args);
  }

  return _emailConfirmationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/mailgun/webhooks(.:format)`
 * - Path helper: `mailgun_webhooks_path`
 * - URL helper: `mailgun_webhooks_url`
 * - controller#action: `mailgun/webhooks#process_webhook`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailgunWebhooksPath = /*#__PURE__*/ (...args) => {
  const _organizationMailgunWebhooksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _mailgunWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationMailgunWebhooksPath(gon.current_organization.path, ...args);
  }

  return _mailgunWebhooksPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/members/mailgun/permanent_failures(.:format)`
 * - Path helper: `members_mailgun_permanent_failures_path`
 * - URL helper: `members_mailgun_permanent_failures_url`
 * - controller#action: `mailgun/webhooks#process_webhook`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membersMailgunPermanentFailuresPath = /*#__PURE__*/ (...args) => {
  const _organizationMembersMailgunPermanentFailuresPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"permanent_failures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _membersMailgunPermanentFailuresPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"permanent_failures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationMembersMailgunPermanentFailuresPath(gon.current_organization.path, ...args);
  }

  return _membersMailgunPermanentFailuresPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/timelogs(.:format)`
 * - Path helper: `timelogs_path`
 * - URL helper: `timelogs_url`
 * - controller#action: `time_tracking/timelogs#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelogsPath = /*#__PURE__*/ (...args) => {
  const _organizationTimelogsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"timelogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _timelogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"timelogs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationTimelogsPath(gon.current_organization.path, ...args);
  }

  return _timelogsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/track_namespace_visits(.:format)`
 * - Path helper: `track_namespace_visits_path`
 * - URL helper: `track_namespace_visits_url`
 * - controller#action: `users/namespace_visits#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackNamespaceVisitsPath = /*#__PURE__*/ (...args) => {
  const _organizationTrackNamespaceVisitsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"track_namespace_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _trackNamespaceVisitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"track_namespace_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationTrackNamespaceVisitsPath(gon.current_organization.path, ...args);
  }

  return _trackNamespaceVisitsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/external_redirect(.:format)`
 * - Path helper: `external_redirect_path`
 * - URL helper: `external_redirect_url`
 * - controller#action: `external_redirect/external_redirect#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalRedirectPath = /*#__PURE__*/ (...args) => {
  const _organizationExternalRedirectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"external_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _externalRedirectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"external_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExternalRedirectPath(gon.current_organization.path, ...args);
  }

  return _externalRedirectPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/collect_events(.:format)`
 * - Path helper: `event_forwarding_path`
 * - URL helper: `event_forwarding_url`
 * - controller#action: `event_forward/event_forward#forward`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventForwardingPath = /*#__PURE__*/ (...args) => {
  const _organizationEventForwardingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"collect_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _eventForwardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"collect_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationEventForwardingPath(gon.current_organization.path, ...args);
  }

  return _eventForwardingPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/experimental/o11y_service_settings(.:format)`
 * - Path helper: `experimental_o11y_service_settings_path`
 * - URL helper: `experimental_o11y_service_settings_url`
 * - controller#action: `experimental/o11y_service_settings#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experimentalO11yServiceSettingsPath = /*#__PURE__*/ (...args) => {
  const _organizationExperimentalO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _experimentalO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExperimentalO11yServiceSettingsPath(gon.current_organization.path, ...args);
  }

  return _experimentalO11yServiceSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/experimental/o11y_service_settings/new(.:format)`
 * - Path helper: `new_experimental_o11y_service_setting_path`
 * - URL helper: `new_experimental_o11y_service_setting_url`
 * - controller#action: `experimental/o11y_service_settings#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExperimentalO11yServiceSettingPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationExperimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newExperimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationExperimentalO11yServiceSettingPath(gon.current_organization.path, ...args);
  }

  return _newExperimentalO11yServiceSettingPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/experimental/o11y_service_settings/:id/edit(.:format)`
 * - Path helper: `edit_experimental_o11y_service_setting_path`
 * - URL helper: `edit_experimental_o11y_service_setting_url`
 * - controller#action: `experimental/o11y_service_settings#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExperimentalO11yServiceSettingPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationExperimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _editExperimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationExperimentalO11yServiceSettingPath(gon.current_organization.path, ...args);
  }

  return _editExperimentalO11yServiceSettingPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/experimental/o11y_service_settings/:id(.:format)`
 * - Path helper: `experimental_o11y_service_setting_path`
 * - URL helper: `experimental_o11y_service_setting_url`
 * - controller#action: `experimental/o11y_service_settings#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experimentalO11yServiceSettingPath = /*#__PURE__*/ (...args) => {
  const _organizationExperimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _experimentalO11yServiceSettingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"experimental"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExperimentalO11yServiceSettingPath(gon.current_organization.path, ...args);
  }

  return _experimentalO11yServiceSettingPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups(.:format)`
 * - Path helper: `groups_path`
 * - URL helper: `groups_url`
 * - controller#action: `groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _groupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupsPath(gon.current_organization.path, ...args);
  }

  return _groupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/new(.:format)`
 * - Path helper: `new_group_path`
 * - URL helper: `new_group_url`
 * - controller#action: `groups#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _newGroupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupPath(gon.current_organization.path, ...args);
  }

  return _newGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/request_access(.:format)`
 * - Path helper: `request_access_group_group_members_path`
 * - URL helper: `request_access_group_group_members_url`
 * - controller#action: `groups/group_members#request_access`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestAccessGroupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _requestAccessOrganizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"request_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _requestAccessGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"request_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _requestAccessOrganizationGroupGroupMembersPath(gon.current_organization.path, ...args);
  }

  return _requestAccessGroupGroupMembersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id/approve_access_request(.:format)`
 * - Path helper: `approve_access_request_group_group_member_path`
 * - URL helper: `approve_access_request_group_group_member_url`
 * - controller#action: `groups/group_members#approve_access_request`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAccessRequestGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _approveAccessRequestOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_access_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _approveAccessRequestGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_access_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _approveAccessRequestOrganizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _approveAccessRequestGroupGroupMemberPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:epic_id/notes/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_group_epic_note_path`
 * - URL helper: `toggle_award_emoji_group_epic_note_url`
 * - controller#action: `groups/epics/notes#toggle_award_emoji`
 *
 * @param {any} groupId
 * @param {any} epicId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiGroupEpicNotePath = /*#__PURE__*/ (...args) => {
  const _toggleAwardEmojiOrganizationGroupEpicNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiGroupEpicNotePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"epic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"epic_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationGroupEpicNotePath(gon.current_organization.path, ...args);
  }

  return _toggleAwardEmojiGroupEpicNotePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/epics/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_group_epic_path`
 * - URL helper: `toggle_award_emoji_group_epic_url`
 * - controller#action: `groups/epics#toggle_award_emoji`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiGroupEpicPath = /*#__PURE__*/ (...args) => {
  const _toggleAwardEmojiOrganizationGroupEpicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiGroupEpicPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"epics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationGroupEpicPath(gon.current_organization.path, ...args);
  }

  return _toggleAwardEmojiGroupEpicPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/connect(.:format)`
 * - Path helper: `connect_group_clusters_path`
 * - URL helper: `connect_group_clusters_url`
 * - controller#action: `groups/clusters#connect`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectGroupClustersPath = /*#__PURE__*/ (...args) => {
  const _connectOrganizationGroupClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _connectGroupClustersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _connectOrganizationGroupClustersPath(gon.current_organization.path, ...args);
  }

  return _connectGroupClustersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/new_cluster_docs(.:format)`
 * - Path helper: `new_cluster_docs_group_clusters_path`
 * - URL helper: `new_cluster_docs_group_clusters_url`
 * - controller#action: `groups/clusters#new_cluster_docs`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newClusterDocsGroupClustersPath = /*#__PURE__*/ (...args) => {
  const _newClusterDocsOrganizationGroupClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"new_cluster_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newClusterDocsGroupClustersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"new_cluster_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newClusterDocsOrganizationGroupClustersPath(gon.current_organization.path, ...args);
  }

  return _newClusterDocsGroupClustersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/create_user(.:format)`
 * - Path helper: `create_user_group_clusters_path`
 * - URL helper: `create_user_group_clusters_url`
 * - controller#action: `groups/clusters#create_user`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createUserGroupClustersPath = /*#__PURE__*/ (...args) => {
  const _createUserOrganizationGroupClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _createUserGroupClustersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _createUserOrganizationGroupClustersPath(gon.current_organization.path, ...args);
  }

  return _createUserGroupClustersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:cluster_id/integration/create_or_update(.:format)`
 * - Path helper: `create_or_update_group_cluster_integration_path`
 * - URL helper: `create_or_update_group_cluster_integration_url`
 * - controller#action: `groups/clusters/integrations#create_or_update`
 *
 * @param {any} groupId
 * @param {any} clusterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createOrUpdateGroupClusterIntegrationPath = /*#__PURE__*/ (...args) => {
  const _createOrUpdateOrganizationGroupClusterIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"cluster_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"cluster_id"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createOrUpdateGroupClusterIntegrationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"cluster_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"cluster_id"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _createOrUpdateOrganizationGroupClusterIntegrationPath(gon.current_organization.path, ...args);
  }

  return _createOrUpdateGroupClusterIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id/environments(.:format)`
 * - Path helper: `environments_group_cluster_path`
 * - URL helper: `environments_group_cluster_url`
 * - controller#action: `groups/clusters#environments`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const environmentsGroupClusterPath = /*#__PURE__*/ (...args) => {
  const _environmentsOrganizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _environmentsGroupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _environmentsOrganizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _environmentsGroupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id/cluster_status(.:format)`
 * - Path helper: `cluster_status_group_cluster_path`
 * - URL helper: `cluster_status_group_cluster_url`
 * - controller#action: `groups/clusters#cluster_status`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clusterStatusGroupClusterPath = /*#__PURE__*/ (...args) => {
  const _clusterStatusOrganizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cluster_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _clusterStatusGroupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cluster_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _clusterStatusOrganizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _clusterStatusGroupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id/clear_cache(.:format)`
 * - Path helper: `clear_cache_group_cluster_path`
 * - URL helper: `clear_cache_group_cluster_url`
 * - controller#action: `groups/clusters#clear_cache`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearCacheGroupClusterPath = /*#__PURE__*/ (...args) => {
  const _clearCacheOrganizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _clearCacheGroupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _clearCacheOrganizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _clearCacheGroupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id/migrate(.:format)`
 * - Path helper: `migrate_group_cluster_path`
 * - URL helper: `migrate_group_cluster_url`
 * - controller#action: `groups/clusters#migrate`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrateGroupClusterPath = /*#__PURE__*/ (...args) => {
  const _migrateOrganizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _migrateGroupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _migrateOrganizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _migrateGroupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id/update_migration(.:format)`
 * - Path helper: `update_migration_group_cluster_path`
 * - URL helper: `update_migration_group_cluster_url`
 * - controller#action: `groups/clusters#update_migration`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMigrationGroupClusterPath = /*#__PURE__*/ (...args) => {
  const _updateMigrationOrganizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _updateMigrationGroupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _updateMigrationOrganizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _updateMigrationGroupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters(.:format)`
 * - Path helper: `group_clusters_path`
 * - URL helper: `group_clusters_url`
 * - controller#action: `groups/clusters#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupClustersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupClustersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupClustersPath(gon.current_organization.path, ...args);
  }

  return _groupClustersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/clusters/:id(.:format)`
 * - Path helper: `group_cluster_path`
 * - URL helper: `group_cluster_url`
 * - controller#action: `groups/clusters#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupClusterPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupClusterPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupClusterPath(gon.current_organization.path, ...args);
  }

  return _groupClusterPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/projects(.:format)`
 * - Path helper: `projects_path`
 * - URL helper: `projects_url`
 * - controller#action: `projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectsPath = /*#__PURE__*/ (...args) => {
  const _organizationProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _projectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProjectsPath(gon.current_organization.path, ...args);
  }

  return _projectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/projects/new(.:format)`
 * - Path helper: `new_project_path`
 * - URL helper: `new_project_url`
 * - controller#action: `projects#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationProjectPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _newProjectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationProjectPath(gon.current_organization.path, ...args);
  }

  return _newProjectPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/connect(.:format)`
 * - Path helper: `connect_admin_clusters_path`
 * - URL helper: `connect_admin_clusters_url`
 * - controller#action: `admin/clusters#connect`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectAdminClustersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/new_cluster_docs(.:format)`
 * - Path helper: `new_cluster_docs_admin_clusters_path`
 * - URL helper: `new_cluster_docs_admin_clusters_url`
 * - controller#action: `admin/clusters#new_cluster_docs`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newClusterDocsAdminClustersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"new_cluster_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/create_user(.:format)`
 * - Path helper: `create_user_admin_clusters_path`
 * - URL helper: `create_user_admin_clusters_url`
 * - controller#action: `admin/clusters#create_user`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createUserAdminClustersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:cluster_id/integration/create_or_update(.:format)`
 * - Path helper: `create_or_update_admin_cluster_integration_path`
 * - URL helper: `create_or_update_admin_cluster_integration_url`
 * - controller#action: `admin/clusters/integrations#create_or_update`
 *
 * @param {any} clusterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createOrUpdateAdminClusterIntegrationPath = /*#__PURE__*/ __jsr.r({"cluster_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"cluster_id"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id/environments(.:format)`
 * - Path helper: `environments_admin_cluster_path`
 * - URL helper: `environments_admin_cluster_url`
 * - controller#action: `admin/clusters#environments`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const environmentsAdminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id/cluster_status(.:format)`
 * - Path helper: `cluster_status_admin_cluster_path`
 * - URL helper: `cluster_status_admin_cluster_url`
 * - controller#action: `admin/clusters#cluster_status`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clusterStatusAdminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cluster_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id/clear_cache(.:format)`
 * - Path helper: `clear_cache_admin_cluster_path`
 * - URL helper: `clear_cache_admin_cluster_url`
 * - controller#action: `admin/clusters#clear_cache`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearCacheAdminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id/migrate(.:format)`
 * - Path helper: `migrate_admin_cluster_path`
 * - URL helper: `migrate_admin_cluster_url`
 * - controller#action: `admin/clusters#migrate`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrateAdminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id/update_migration(.:format)`
 * - Path helper: `update_migration_admin_cluster_path`
 * - URL helper: `update_migration_admin_cluster_url`
 * - controller#action: `admin/clusters#update_migration`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMigrationAdminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters(.:format)`
 * - Path helper: `admin_clusters_path`
 * - URL helper: `admin_clusters_url`
 * - controller#action: `admin/clusters#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClustersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/admin/clusters/:id(.:format)`
 * - Path helper: `admin_cluster_path`
 * - URL helper: `admin_cluster_url`
 * - controller#action: `admin/clusters#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClusterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_in(.:format)`
 * - Path helper: `new_user_session_path`
 * - URL helper: `new_user_session_url`
 * - controller#action: `sessions#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationUserSessionPath(gon.current_organization.path, ...args);
  }

  return _newUserSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_in(.:format)`
 * - Path helper: `user_session_path`
 * - URL helper: `user_session_url`
 * - controller#action: `sessions#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserSessionPath(gon.current_organization.path, ...args);
  }

  return _userSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_out(.:format)`
 * - Path helper: `destroy_user_session_path`
 * - URL helper: `destroy_user_session_url`
 * - controller#action: `sessions#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionPath = /*#__PURE__*/ (...args) => {
  const _destroyOrganizationUserSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _destroyUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _destroyOrganizationUserSessionPath(gon.current_organization.path, ...args);
  }

  return _destroyUserSessionPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/alicloud(.:format)`
 * - Path helper: `user_alicloud_omniauth_authorize_path`
 * - URL helper: `user_alicloud_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAlicloudOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"alicloud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/alicloud/callback(.:format)`
 * - Path helper: `user_alicloud_omniauth_callback_path`
 * - URL helper: `user_alicloud_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#alicloud`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAlicloudOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"alicloud"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/github(.:format)`
 * - Path helper: `user_github_omniauth_authorize_path`
 * - URL helper: `user_github_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGithubOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"github"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/github/callback(.:format)`
 * - Path helper: `user_github_omniauth_callback_path`
 * - URL helper: `user_github_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#github`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGithubOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"github"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/bitbucket(.:format)`
 * - Path helper: `user_bitbucket_omniauth_authorize_path`
 * - URL helper: `user_bitbucket_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBitbucketOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"bitbucket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/bitbucket/callback(.:format)`
 * - Path helper: `user_bitbucket_omniauth_callback_path`
 * - URL helper: `user_bitbucket_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#bitbucket`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBitbucketOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"bitbucket"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/gitlab(.:format)`
 * - Path helper: `user_gitlab_omniauth_authorize_path`
 * - URL helper: `user_gitlab_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGitlabOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/gitlab/callback(.:format)`
 * - Path helper: `user_gitlab_omniauth_callback_path`
 * - URL helper: `user_gitlab_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#gitlab`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGitlabOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"gitlab"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/google_oauth2(.:format)`
 * - Path helper: `user_google_oauth2_omniauth_authorize_path`
 * - URL helper: `user_google_oauth2_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/google_oauth2/callback(.:format)`
 * - Path helper: `user_google_oauth2_omniauth_callback_path`
 * - URL helper: `user_google_oauth2_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#google_oauth2`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/jwt(.:format)`
 * - Path helper: `user_jwt_omniauth_authorize_path`
 * - URL helper: `user_jwt_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userJwtOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"jwt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/jwt/callback(.:format)`
 * - Path helper: `user_jwt_omniauth_callback_path`
 * - URL helper: `user_jwt_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#jwt`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userJwtOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"jwt"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/auth0(.:format)`
 * - Path helper: `user_auth0_omniauth_authorize_path`
 * - URL helper: `user_auth0_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAuth0OmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"auth0"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/auth0/callback(.:format)`
 * - Path helper: `user_auth0_omniauth_callback_path`
 * - URL helper: `user_auth0_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#auth0`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAuth0OmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"auth0"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/salesforce(.:format)`
 * - Path helper: `user_salesforce_omniauth_authorize_path`
 * - URL helper: `user_salesforce_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSalesforceOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"salesforce"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/salesforce/callback(.:format)`
 * - Path helper: `user_salesforce_omniauth_callback_path`
 * - URL helper: `user_salesforce_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#salesforce`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSalesforceOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/atlassian_oauth2(.:format)`
 * - Path helper: `user_atlassian_oauth2_omniauth_authorize_path`
 * - URL helper: `user_atlassian_oauth2_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAtlassianOauth2OmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"atlassian_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/atlassian_oauth2/callback(.:format)`
 * - Path helper: `user_atlassian_oauth2_omniauth_callback_path`
 * - URL helper: `user_atlassian_oauth2_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#atlassian_oauth2`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAtlassianOauth2OmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"atlassian_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/openid_connect(.:format)`
 * - Path helper: `user_openid_connect_omniauth_authorize_path`
 * - URL helper: `user_openid_connect_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userOpenidConnectOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"openid_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/openid_connect/callback(.:format)`
 * - Path helper: `user_openid_connect_omniauth_callback_path`
 * - URL helper: `user_openid_connect_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#openid_connect`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userOpenidConnectOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"openid_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/group_saml(.:format)`
 * - Path helper: `user_group_saml_omniauth_authorize_path`
 * - URL helper: `user_group_saml_omniauth_authorize_url`
 * - controller#action: `omniauth_callbacks#passthru`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGroupSamlOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"group_saml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/group_saml/callback(.:format)`
 * - Path helper: `user_group_saml_omniauth_callback_path`
 * - URL helper: `user_group_saml_omniauth_callback_url`
 * - controller#action: `omniauth_callbacks#group_saml`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGroupSamlOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"group_saml"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates the Rails route:
 *
 * - href: `/users/password/new(.:format)`
 * - Path helper: `new_user_password_path`
 * - URL helper: `new_user_password_url`
 * - controller#action: `passwords#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationUserPasswordPath(gon.current_organization.path, ...args);
  }

  return _newUserPasswordPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/password/edit(.:format)`
 * - Path helper: `edit_user_password_path`
 * - URL helper: `edit_user_password_url`
 * - controller#action: `passwords#edit`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationUserPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _editUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationUserPasswordPath(gon.current_organization.path, ...args);
  }

  return _editUserPasswordPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/password(.:format)`
 * - Path helper: `user_password_path`
 * - URL helper: `user_password_url`
 * - controller#action: `passwords#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ (...args) => {
  const _organizationUserPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserPasswordPath(gon.current_organization.path, ...args);
  }

  return _userPasswordPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/cancel(.:format)`
 * - Path helper: `cancel_user_registration_path`
 * - URL helper: `cancel_user_registration_url`
 * - controller#action: `registrations#cancel`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationPath = /*#__PURE__*/ (...args) => {
  const _cancelOrganizationUserRegistrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _cancelUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _cancelOrganizationUserRegistrationPath(gon.current_organization.path, ...args);
  }

  return _cancelUserRegistrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_up(.:format)`
 * - Path helper: `new_user_registration_path`
 * - URL helper: `new_user_registration_url`
 * - controller#action: `registrations#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserRegistrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _newUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationUserRegistrationPath(gon.current_organization.path, ...args);
  }

  return _newUserRegistrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/edit(.:format)`
 * - Path helper: `edit_user_registration_path`
 * - URL helper: `edit_user_registration_url`
 * - controller#action: `registrations#edit`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationUserRegistrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _editUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationUserRegistrationPath(gon.current_organization.path, ...args);
  }

  return _editUserRegistrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users(.:format)`
 * - Path helper: `user_registration_path`
 * - URL helper: `user_registration_url`
 * - controller#action: `registrations#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationPath = /*#__PURE__*/ (...args) => {
  const _organizationUserRegistrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _userRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserRegistrationPath(gon.current_organization.path, ...args);
  }

  return _userRegistrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/confirmation/new(.:format)`
 * - Path helper: `new_user_confirmation_path`
 * - URL helper: `new_user_confirmation_url`
 * - controller#action: `confirmations#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserConfirmationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newUserConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationUserConfirmationPath(gon.current_organization.path, ...args);
  }

  return _newUserConfirmationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/confirmation(.:format)`
 * - Path helper: `user_confirmation_path`
 * - URL helper: `user_confirmation_url`
 * - controller#action: `confirmations#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userConfirmationPath = /*#__PURE__*/ (...args) => {
  const _organizationUserConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserConfirmationPath(gon.current_organization.path, ...args);
  }

  return _userConfirmationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/unlock/new(.:format)`
 * - Path helper: `new_user_unlock_path`
 * - URL helper: `new_user_unlock_url`
 * - controller#action: `devise/unlocks#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserUnlockPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserUnlockPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _newUserUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationUserUnlockPath(gon.current_organization.path, ...args);
  }

  return _newUserUnlockPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/unlock(.:format)`
 * - Path helper: `user_unlock_path`
 * - URL helper: `user_unlock_url`
 * - controller#action: `devise/unlocks#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUnlockPath = /*#__PURE__*/ (...args) => {
  const _organizationUserUnlockPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserUnlockPath(gon.current_organization.path, ...args);
  }

  return _userUnlockPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/security/vulnerabilities/:vulnerability_id/notes/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_project_security_vulnerability_note_path`
 * - URL helper: `toggle_award_emoji_project_security_vulnerability_note_url`
 * - controller#action: `projects/security/vulnerabilities/notes#toggle_award_emoji`
 *
 * @param {string} projectFullPath
 * @param {any} vulnerabilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleAwardEmojiOrganizationNamespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiNamespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationNamespaceProjectSecurityVulnerabilityNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleAwardEmojiNamespaceProjectSecurityVulnerabilityNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/project_members/request_access(.:format)`
 * - Path helper: `request_access_project_project_members_path`
 * - URL helper: `request_access_project_project_members_url`
 * - controller#action: `projects/project_members#request_access`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestAccessProjectProjectMembersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _requestAccessOrganizationNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"request_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _requestAccessNamespaceProjectProjectMembersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[6,"request_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _requestAccessOrganizationNamespaceProjectProjectMembersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _requestAccessNamespaceProjectProjectMembersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/project_members/:id/approve_access_request(.:format)`
 * - Path helper: `approve_access_request_project_project_member_path`
 * - URL helper: `approve_access_request_project_project_member_url`
 * - controller#action: `projects/project_members#approve_access_request`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAccessRequestProjectProjectMemberPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _approveAccessRequestOrganizationNamespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_access_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _approveAccessRequestNamespaceProjectProjectMemberPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"project_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve_access_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _approveAccessRequestOrganizationNamespaceProjectProjectMemberPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _approveAccessRequestNamespaceProjectProjectMemberPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/connect(.:format)`
 * - Path helper: `connect_project_clusters_path`
 * - URL helper: `connect_project_clusters_url`
 * - controller#action: `projects/clusters#connect`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectProjectClustersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _connectOrganizationNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _connectNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _connectOrganizationNamespaceProjectClustersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _connectNamespaceProjectClustersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/new_cluster_docs(.:format)`
 * - Path helper: `new_cluster_docs_project_clusters_path`
 * - URL helper: `new_cluster_docs_project_clusters_url`
 * - controller#action: `projects/clusters#new_cluster_docs`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newClusterDocsProjectClustersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newClusterDocsOrganizationNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"new_cluster_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newClusterDocsNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"new_cluster_docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newClusterDocsOrganizationNamespaceProjectClustersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newClusterDocsNamespaceProjectClustersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/create_user(.:format)`
 * - Path helper: `create_user_project_clusters_path`
 * - URL helper: `create_user_project_clusters_url`
 * - controller#action: `projects/clusters#create_user`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createUserProjectClustersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _createUserOrganizationNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _createUserNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[6,"create_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _createUserOrganizationNamespaceProjectClustersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _createUserNamespaceProjectClustersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:cluster_id/integration/create_or_update(.:format)`
 * - Path helper: `create_or_update_project_cluster_integration_path`
 * - URL helper: `create_or_update_project_cluster_integration_url`
 * - controller#action: `projects/clusters/integrations#create_or_update`
 *
 * @param {string} projectFullPath
 * @param {any} clusterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createOrUpdateProjectClusterIntegrationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _createOrUpdateOrganizationNamespaceProjectClusterIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"cluster_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"cluster_id"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createOrUpdateNamespaceProjectClusterIntegrationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"cluster_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"cluster_id"],[2,[7,"/"],[2,[6,"integration"],[2,[7,"/"],[2,[6,"create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _createOrUpdateOrganizationNamespaceProjectClusterIntegrationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _createOrUpdateNamespaceProjectClusterIntegrationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id/environments(.:format)`
 * - Path helper: `environments_project_cluster_path`
 * - URL helper: `environments_project_cluster_url`
 * - controller#action: `projects/clusters#environments`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const environmentsProjectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _environmentsOrganizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _environmentsNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _environmentsOrganizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _environmentsNamespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id/cluster_status(.:format)`
 * - Path helper: `cluster_status_project_cluster_path`
 * - URL helper: `cluster_status_project_cluster_url`
 * - controller#action: `projects/clusters#cluster_status`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clusterStatusProjectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _clusterStatusOrganizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cluster_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _clusterStatusNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cluster_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _clusterStatusOrganizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _clusterStatusNamespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id/clear_cache(.:format)`
 * - Path helper: `clear_cache_project_cluster_path`
 * - URL helper: `clear_cache_project_cluster_url`
 * - controller#action: `projects/clusters#clear_cache`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearCacheProjectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _clearCacheOrganizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _clearCacheNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _clearCacheOrganizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _clearCacheNamespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id/migrate(.:format)`
 * - Path helper: `migrate_project_cluster_path`
 * - URL helper: `migrate_project_cluster_url`
 * - controller#action: `projects/clusters#migrate`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrateProjectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _migrateOrganizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _migrateNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _migrateOrganizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _migrateNamespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id/update_migration(.:format)`
 * - Path helper: `update_migration_project_cluster_path`
 * - URL helper: `update_migration_project_cluster_url`
 * - controller#action: `projects/clusters#update_migration`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateMigrationProjectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _updateMigrationOrganizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _updateMigrationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_migration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _updateMigrationOrganizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _updateMigrationNamespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters(.:format)`
 * - Path helper: `project_clusters_path`
 * - URL helper: `project_clusters_url`
 * - controller#action: `projects/clusters#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectClustersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectClustersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectClustersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectClustersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/clusters/:id(.:format)`
 * - Path helper: `project_cluster_path`
 * - URL helper: `project_cluster_url`
 * - controller#action: `projects/clusters#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectClusterPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectClusterPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"clusters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectClusterPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectClusterPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/issues/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_project_issue_path`
 * - URL helper: `toggle_award_emoji_project_issue_url`
 * - controller#action: `projects/issues#toggle_award_emoji`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiProjectIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleAwardEmojiOrganizationNamespaceProjectIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiNamespaceProjectIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationNamespaceProjectIssuePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleAwardEmojiNamespaceProjectIssuePath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_project_merge_request_path`
 * - URL helper: `toggle_award_emoji_project_merge_request_url`
 * - controller#action: `projects/merge_requests#toggle_award_emoji`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleAwardEmojiOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationNamespaceProjectMergeRequestPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleAwardEmojiNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/snippets/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_project_snippet_path`
 * - URL helper: `toggle_award_emoji_project_snippet_url`
 * - controller#action: `projects/snippets#toggle_award_emoji`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiProjectSnippetPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleAwardEmojiOrganizationNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiNamespaceProjectSnippetPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationNamespaceProjectSnippetPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleAwardEmojiNamespaceProjectSnippetPath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/notes/:id/toggle_award_emoji(.:format)`
 * - Path helper: `toggle_award_emoji_project_note_path`
 * - URL helper: `toggle_award_emoji_project_note_url`
 * - controller#action: `projects/notes#toggle_award_emoji`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleAwardEmojiProjectNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleAwardEmojiOrganizationNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _toggleAwardEmojiNamespaceProjectNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_award_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleAwardEmojiOrganizationNamespaceProjectNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleAwardEmojiNamespaceProjectNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/snippets/:id/raw`
 * - Path helper: `deprecated_path`
 * - URL helper: `deprecated_url`
 * - controller#action: `snippets#raw`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deprecatedPath = /*#__PURE__*/ (...args) => {
  const _organizationDeprecatedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"raw"]]]]]]]]]]);
  const _deprecatedPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"snippets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"raw"]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDeprecatedPath(gon.current_organization.path, ...args);
  }

  return _deprecatedPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/sitemap(.:format)`
 * - Path helper: `sitemap_path`
 * - URL helper: `sitemap_url`
 * - controller#action: `sitemap#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapPath = /*#__PURE__*/ (...args) => {
  const _organizationSitemapPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _sitemapPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationSitemapPath(gon.current_organization.path, ...args);
  }

  return _sitemapPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/`
 * - Path helper: `root_path`
 * - URL helper: `root_url`
 * - controller#action: `root#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ (...args) => {
  const _organizationRootPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[1,[2,[8,"."],[3,"format"]]]]]]]);
  const _rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

  if (hasOrganizationScopedPaths()) {
    return _organizationRootPath(gon.current_organization.path, ...args);
  }

  return _rootPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/namespace/:namespace_id/sent_notifications/:id/unsubscribe(.:format)`
 * - Path helper: `unsubscribe_namespace_sent_notification_path`
 * - URL helper: `unsubscribe_namespace_sent_notification_url`
 * - controller#action: `sent_notifications#unsubscribe`
 *
 * @param {any} namespaceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeNamespaceSentNotificationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"namespace"],[2,[7,"/"],[2,[3,"namespace_id"],[2,[7,"/"],[2,[6,"sent_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

